import React, { useState } from "react";
import { Link } from "react-router-dom";

import postImg from "../../images/blog-post.webp";

// functions
import { limitString, randomColor } from "../../helper/helper";
import CircleLoading from "../shared/CircleLoading";

const BlogCard = ({ data, type }) => {
  const [loading, setLoading] = useState(false);

  return (
    <div className="bg-[#222] xl:w-full text-gray-200 h-auto flex flex-col gap-5 rounded-2xl shadow-[0px_5px_25px_rgba(79,105,139,.09)] group hover:shadow-xl transition-all duration-300">
      {/* post image */}
      <Link
        to={`/news/${data.slug}`}
        className="post-img w-full relative overflow-hidden rounded-t-2xl"
      >
        {!loading && (
          <div className="w-full h-[208px] rounded-t-2xl bg-gray-800 flex justify-center items-center">
            <CircleLoading />
          </div>
        )}

        <img
          src={`https://api.myunibest.com/${data.image}`}
          // src={postImg}
          className={`w-full ${
            !loading && "hidden"
          } rounded-t-2xl object-cover transition-all duration-300`}
          onLoad={() => setLoading(true)}
        />
      </Link>

      <div className="w-full flex flex-col gap-5 p-5 pt-0">
        {/* post title */}
        <div className="relative flex items-center gap-2 text-xl font-black">
          <span className="block w-5 h-2 rounded-full bg-yellow-700"></span>
          <Link
            to={`/news/${data.slug}`}
            className="text-gray-200 line-clamp-1"
          >
            {data.title}
          </Link>
        </div>

        {/* post desc */}
        <div className="post-desc text-xs text-gray-400">
          <p className="break-words line-clamp-3">{data.description}</p>
        </div>

        {/* post details */}
        <div className="flex items-center gap-5">
          <div className="flex items-center text-gray-400 text-xs gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-4 h-4 fill-gray-400"
            >
              <path d="M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
              <path
                fillRule="evenodd"
                d="M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z"
                clipRule="evenodd"
              />
            </svg>

            <span className="">
              {new Intl.DateTimeFormat("fa-IR", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(data.updated_at))}
            </span>
          </div>

          <div className="flex items-center text-gray-400 text-xs gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-4 h-4 fill-gray-400"
            >
              <path
                fillRule="evenodd"
                d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z"
                clipRule="evenodd"
              />
            </svg>

            <span className="">
              یونی بست
            </span>
          </div>
        </div>

        {/* post button */}
        <div className="post-readmore w-full flex justify-center items-center pt-4 gap-3 border-t border-gray-800 ">
          <Link
            to={type === 1 ? `/magazine/${data.slug}` : `/news/${data.slug}`}
            className="flex items-center gap-2 text-center group text-[15px] text-white rounded-xl transition-all duration-300"
          >
            <span className="group-hover:text-yellow-700 transition-all duration-300">
              مطالعه مقاله
            </span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-6 h-6 group-hover:fill-yellow-700 transition-all duration-300"
            >
              <path
                fill-rule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-4.28 9.22a.75.75 0 0 0 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-1.72-1.72h5.69a.75.75 0 0 0 0-1.5h-5.69l1.72-1.72a.75.75 0 0 0-1.06-1.06l-3 3Z"
                clip-rule="evenodd"
              />
            </svg>
          </Link>

          {/* tag - category */}
          {/* <div className="flex flex-col gap-2">
          {data.categories.length > 0 ? (
            <Link
              to={`/blog-category/${data.categories[0].category?.slug}`}
              className="flex items-center gap-2"
            >
              <span className="block bg-blue-50 text-sm text-blue-600 hover:bg-yellow-700 hover:text-white transition-all duration-300 rounded-lg px-3 py-2">
                {data.categories[0].category?.name}
              </span>
            </Link>
          ) : (
            <div className="flex items-center gap-2">
              <span className="block bg-blue-50 text-sm text-blue-600 hover:bg-yellow-700 hover:text-white transition-all duration-300 rounded-lg px-3 py-2">
                دسته بندی نشده
              </span>
            </div>
          )}
        </div> */}
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
